const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});